import React from "react";

/**
 * Editorial slow-drift marquee band.
 * Single tasteful moment between sections — not a decorative gimmick.
 */
export default function Marquee() {
  const words = [
    "Consistency",
    "Discipline",
    "Willpower",
    "Nourish",
    "Rewire",
    "Transform",
    "Heal",
    "Live Well",
  ];
  const strip = [...words, ...words, ...words];

  return (
    <section
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="relative py-14 md:py-20 overflow-hidden select-none"
    >
      <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#140326] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#140326] to-transparent z-10 pointer-events-none" />

      <div className="flex whitespace-nowrap marquee-editorial">
        {strip.map((w, i) => (
          <span
            key={`${w}-${i}`}
            className="inline-flex items-center gap-10 md:gap-16 font-display font-extrabold text-6xl md:text-8xl lg:text-9xl tracking-tight px-6 md:px-10"
          >
            <span
              className={
                i % 2 === 0
                  ? "text-white/95"
                  : "gradient-text opacity-90"
              }
              style={{
                WebkitTextStroke: i % 2 === 0 ? "0" : undefined,
              }}
            >
              {w}.
            </span>
            <span className="text-[#27C6FF]/70 text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
